<template>
  <path
    d="M17.6568 16.2427L19.071 14.8285L12 7.75737L4.92893 14.8284L6.34314 16.2426L12 10.5858L17.6568 16.2427Z"
    fill="currentColor"
  />
</template>
